import React, { useEffect, useState } from "react";
import "../../../stylesheet/forms.css";

// const patientsData = ();

const Patients = ({ formData, updateFormData, mode }) => {
  const [patientForm, setPatientForm] = useState({...formData});

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setPatientForm({
      patient: {
        ...patientForm,
        [name]: value,
      },
    });
    let today = Date.now();
    const formatter = new Intl.DateTimeFormat([], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    today = formatter.format(today);
    const joinedDate = today;
    const synced = false;
    updateFormData({
      patient: {
        ...formData,
        status: "Active",
        synced,
        joinedDate,
        [name]: value,
      },
    });
  };
  // useEffect(() => {
  //   if (formData.name) {
  //     setPatientForm(formData);
  //   }
  // }, []);

  return (
    <div className="step_form">
      {!mode ? (
        <>
          <div className="step_input">
            <label htmlFor="name">Patient name</label>
            <input
              name="name"
              value={patientForm.name}
              type="text"
              placeholder="Enter patient name"
              onChange={handleInputChange}
            />
          </div>
          <div className="step_input">
            <label htmlFor="gender">Gender</label>
            <select
              name="gender"
              id="gender"
              aria-label="Select patient gender"
              value={patientForm.gender}
              onChange={handleInputChange}
            >
              <option value="" disabled selected>
                Select patient gender
              </option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>

          {/* <div className="step_input">
        <label htmlFor="contactInput">Contact details (Phone or email)</label>
        <input
          onChange={handleInputChange}
          name="contactInput"
          type="text"
          id="contactInput"
          placeholder="Enter contact information"
          inputMode="numeric"
          pattern="[0-9]*"
        />
      </div> */}
          <div className="w-full">
            <div className="flex justify-between gap-4">
              <div className="w-1/2">
                <div className="step_input">
                  <label htmlFor="phoneNumber">Phone</label>
                  <input
                    onChange={handleInputChange}
                    name="phoneNumber"
                    type="tel"
                    value={patientForm.phoneNumber}
                    id="phoneNumber"
                    placeholder="Enter Phone Number"
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div>
              </div>
              <div className="w-1/2">
                <div className="step_input">
                  <label htmlFor="email">Email</label>
                  <input
                    onChange={handleInputChange}
                    name="email"
                    type="email"
                    value={patientForm.email}
                    required
                    id="email"
                    placeholder="Enter Email"
                    inputMode="email"
                    pattern="[0-9]*"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="step_input">
            <label htmlFor="age">Age</label>
            <input
              onChange={handleInputChange}
              name="age"
              type="text"
              value={patientForm.age}
              id="age"
              placeholder="Enter age"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>

          <div className="step_input">
            <label htmlFor="pulse">Pulse(bpm)</label>
            <input
              onChange={handleInputChange}
              name="pulse"
              type="text"
              value={patientForm.pulse}
              id="pulse"
              placeholder="Enter pulse"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>

          <div className="step_input">
            <label htmlFor="weight">Weight(kg)</label>
            <input
              onChange={handleInputChange}
              name="weight"
              type="text"
              value={patientForm.weight}
              id="weight"
              placeholder="Enter weight"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>

          <div className="step_input">
            <label htmlFor="height">Height(cm)</label>
            <input
              onChange={handleInputChange}
              name="height"
              type="text"
              value={patientForm.height}
              id="height"
              placeholder="Enter height"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>

          <div className="step_double">
            <div className="step_inputs">
              <label htmlFor="systolic">Systolic (mmHg)</label>
              <input
                onChange={handleInputChange}
                name="systolic"
                type="text"
                value={patientForm.systolic}
                id="systolic"
                placeholder="Enter value"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
            <div className="slash">/</div>
            <div className="step_inputs">
              <label htmlFor="diastolic">Diastolic (mmHg)</label>
              <input
                onChange={handleInputChange}
                name="diastolic"
                value={patientForm.diastolic}
                type="text"
                id="diastolic"
                placeholder="Enter value"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
          </div>

          <div className="step_input">
            <label htmlFor="temperature">Temperature (°C)</label>
            <input
              onChange={handleInputChange}
              name="temperature"
              type="text"
              value={patientForm.temperature}
              id="temperature"
              placeholder="Enter value"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>

          <div className="step_input">
            <label htmlFor="sugar_level">Sugar Level (mg/dL)</label>
            <input
              onChange={handleInputChange}
              name="sugar_level"
              type="text"
              value={patientForm.sugar_level}
              id="sugar_level"
              placeholder="Enter value"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>
        </>
      ) : (
        <></>
      )}

      <div className="step_input">
        <label htmlFor="complaints">Chief Complaints</label>
        <textarea
          onChange={handleInputChange}
          placeholder="Enter a description..."
          name="complaints"
          value={patientForm.complaints}
          id="complaints"
          rows="7"
        ></textarea>
      </div>

      <div className="step_input">
        <label htmlFor="examination">On Examination</label>
        <textarea
          onChange={handleInputChange}
          placeholder="Enter a description..."
          name="examination"
          value={patientForm.examination}
          id="examination"
          rows="7"
        ></textarea>
      </div>

      <div className="step_input">
        <label htmlFor="diagnosis">Diagnosis</label>
        <textarea
          onChange={handleInputChange}
          placeholder="Enter a description..."
          name="diagnosis"
          value={patientForm.diagnosis}
          id="diagnosis"
          rows="7"
        ></textarea>
      </div>
    </div>
  );
};

export default Patients;
